export function sleep(delay: number) {
  return new Promise(function (resolve) {
    setTimeout(resolve, delay);
  });
}
